import React from 'react';
import { useHistory } from 'react-router-dom';
import './ResolutionSuccessPage.css';

/**
 * Success page shown after single item resolution is submitted.
 */
const ResolutionSuccessPage = () => {
	const history = useHistory();

	const handleGoToDashboard = () => {
		history.push('/dashboard');
	};

	return (
		<div className="resolution-success-page">
			<div className="success-container">
				<div className="success-icon">
					<svg
						width="80"
						height="80"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						strokeWidth="2"
					>
						<circle cx="12" cy="12" r="10" />
						<path
							d="M9 12l2 2 4-4"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</div>

				<h1>Request Submitted Successfully</h1>

				<div className="success-message">
					<p className="message-text">
						Your resolution request has been submitted to our team.
					</p>
					<p className="message-subtext">
						We'll contact you shortly to discuss resolution options.
					</p>
				</div>

				<div className="success-actions">
					<button className="btn btn-primary" onClick={handleGoToDashboard}>
						Go to Dashboard
					</button>
				</div>

				<div className="confirmation-note">
					<p>
						A confirmation email has been sent to your inbox with the details of
						your request.
					</p>
				</div>
			</div>
		</div>
	);
};

export default ResolutionSuccessPage;
